import { render, staticRenderFns } from "./SkillLevels.vue?vue&type=template&id=00f48388&scoped=true&"
import script from "./SkillLevels.vue?vue&type=script&lang=js&"
export * from "./SkillLevels.vue?vue&type=script&lang=js&"
import style0 from "./SkillLevels.vue?vue&type=style&index=0&id=00f48388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f48388",
  null
  
)

export default component.exports